import { Github } from "lucide-react";
import packageJson from "../../../../../../package.json";

const REPO_URL = "https://github.com/yousseffarkhani/opera-off-frontend";

export const DesignSystemFooter = () => (
  <footer className="mt-10 flex flex-wrap items-center justify-between gap-2 border-t pt-4 text-xs text-muted-foreground">
    <span>
      Version <span className="font-mono">{packageJson.version}</span>
    </span>
    <a
      href={REPO_URL}
      target="_blank"
      rel="noreferrer noopener"
      className="inline-flex items-center gap-1.5 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <Github className="size-3.5" aria-hidden="true" />
      <span>Code source</span>
    </a>
  </footer>
);
